export enum ECardCategoryThemesIds {
  MO_CLASSICS = 'moclassics',
  DIY = 'diy',
  REGIONAL = 'regional',
  THEMES = 'themes',
}

export enum ECardThemesIds {
  FACES = 'moriginal',
  FLOW = 'moaitopia',
  GOGH = 'mogogh',
  STICKERS = 'modoodle',
  CADE = 'mocade',
  ZODIAC = 'mozodiac',
  FRESH = 'mofresh',
  BURST = 'moburst',
  PURPLE = 'mopurple',
  GREEN = 'mogreen',
  OHIO = 'moohio',
  TEXAS = 'motexas',
  YELLOWSTONE = 'moyellowstone',
  DESERT = 'modesert',
  FOOTBALL = 'mofootball',
  SUNSET = 'mosunset',
  GAMING = 'mogaming',
  ARCADE = 'moarcade',
  CHARMINAR = 'mocharminar',
}

export interface ICardThemesResponse {
  themes: ECardThemesIds[];
}

export interface ICardThemesV2Response {
  category: ECardCategoryThemesIds;
  themes: ECardThemesIds[];
}

export interface CardThemeModel {
  themes: ECardThemesIds[];
}

export interface CardThemesV2Model {
  category: ECardCategoryThemesIds;
  themes: ECardThemesIds[];
}
